export const resultList = [
  { value: 'dt_evt', text: 'Date' },
  { value: 't_moy', text: 'Température moyenne calculée' },
  { value: 'nc_dj', text: 'NC MWh (PCI) / DJ' },
  { value: 'nc_dj_obj', text: 'Objectif technique MWh (PCI) / DJ' },
  { value: 'conso_tot', text: 'Conso Totale MWh PCI' },
  { value: 'conso_tot_obj', text: 'Conso Totale théorique MWh PCI' },
  { value: 'conso_eltr_mwhpci', text: 'Conso élémentaire MWh PCI' },
  {
    value: 'theo_eltr_mwhpci',
    text: 'Conso élémentaire Théorique MWh PCI',
  },
  { value: 'conso_hecs_mwhpci', text: 'Conso Hors ECS MWh PCI' },
  {
    value: 'theo_hecs_mwhpci_djr',
    text: 'Conso Hors ECS Théorique MWh PCI',
  },
  { value: 'ecart_total_global', text: 'Ecart total' },
  { value: 'ecart_total_pct', text: 'Ecart total %' },
  { value: 'ecart_cond', text: 'Ecart de conduite' },
  { value: 'ecart_cond_mwhpci', text: 'Ecart conduite MWh PCI' },
  { value: 'ecart_cond_pct', text: 'Ecart conduite %' },
  { value: 'cs', text: 'CS' },
  { value: 'cs_theo', text: 'CS Théorique' },
  { value: 'prod_mwh', text: 'Production MWh' },
  { value: 'prod_unt', text: 'Production Unité' },
  { value: 'theo_prod_unt', text: 'Production Théorique Unité' },
  { value: 'prod_idx_unt', text: 'Production indexée Unité' },
  {
    value: 'theo_prod_idx_mwh',
    text: 'Production Théorique indexée MWh',
  },
  { value: 'prod_tot', text: 'Production Totale MWh' },
  { value: 'prod_tot_obj', text: 'Production Totale Théorique MWh' },
  { value: 'ecart_prod', text: 'Ecart de production MWh' },
  { value: 'ecart_prod_pct', text: 'Ecart de production %' },
  { value: 'ecart_q_mwhpci', text: 'Ecart q MWh PCI' },
  { value: 'qreel_comb', text: 'q réel Combustible' },
  { value: 'qreel_ener', text: 'q réel Energie' },
  { value: 'prod_comb', text: 'Prod ECS unt Combustible' },
  { value: 'ecart_q_ecs_hc', text: 'Ecart q Hors Chauffe' },
  { value: 'q_ecs_hc', text: 'q Hors Chauffe' },
  { value: 'q_ecs_hc_obj', text: 'q théorique Hors Chauffe' },
  { value: 'ecs_j', text: 'ECS par jour' },
  { value: 'ecs_j_obj', text: 'ECS Théorique par jour' },
  { value: 'ecs_m3', text: 'ECS M3' },
  { value: 'nbjour', text: 'Nombre jours releve' },
  { value: 'nbjour_chauffe', text: 'Nombre jours chauffe releve' },
  { value: 'dj_reel', text: 'DJ réels' },
  { value: 'rigueur', text: 'Rigueur' },
  { value: 'nb_dj_mwh', text: 'NB Contrat par DJ contrat (MWh)' },
];

export const monthLabels = [
  { id: '01', name: 'Janvier' },
  { id: '02', name: 'Février' },
  { id: '03', name: 'Mars' },
  { id: '04', name: 'Avril' },
  { id: '05', name: 'Mai' },
  { id: '06', name: 'Juin' },
  { id: '07', name: 'Juillet' },
  { id: '08', name: 'Aout' },
  { id: '09', name: 'Septembre' },
  { id: '10', name: 'Octobre' },
  { id: '11', name: 'Novembre' },
  { id: '12', name: 'Décembre' },
];

export function showColor(val, rgba = '') {
  if (this.$vuetify && this.$vuetify.theme.themes) {
    return this.$vuetify.theme.isDark
      ? `${this.$vuetify.theme.themes.dark[val]}${rgba}`
      : `${this.$vuetify.theme.themes.light[val]}${rgba}`;
  }
  return '#000000';
}
